export default __webpack_public_path__ + "static/media/1 Set Goal.5d4af43c.png";